<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Incomplete Visits
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Incomplete Subject Followups
      </p>
    </b-container>

    <b-container>
      <b-row>
      <b-col lg="4"></b-col>
      <b-col lg="4"></b-col>
      <b-col lg="4">
        <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>
    </b-row>
    </b-container>
    <hr>

     <b-card no-body>
        <b-tabs card fill>
          <b-tab :title="'INCOMPLETE VISITS ('+visits.length+')'" active>
            <b-card-text >
              <b-table striped hover :fields="fields" :items="visits" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">
                <template v-slot:cell(table_name)="data">
                  <span v-if="data.item.table_name == 'compound_followup_incomplete_visit'">Compound</span>
                  <span v-if="data.item.table_name == 'clinic_followup_incomplete_visit'">Clinic</span>
                </template>

                <template v-slot:cell(dismiss)="data">
                  <b-button class="btn-success" @click="dismiss_clicked(data.item)"><i class="fa fa-check"></i></b-button>
                </template>
              </b-table>
            </b-card-text>
          </b-tab>

          <b-tab :title="'DISMISSED ('+dismissed_visits.length+')'">
            <b-card-text >

              <b-table striped hover :fields="dismissed_fields" :items="dismissed_visits" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">
                <template v-slot:cell(table_name)="data">
                  <span v-if="data.item.table_name == 'compound_followup_incomplete_visit'">Compound</span>
                  <span v-if="data.item.table_name == 'clinic_followup_incomplete_visit'">Clinic</span>
                </template>
                <template v-slot:cell(subject_name)="data">
                  {{ data.item.subject_case.subject_name }}
                </template>
              
              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
     </b-card>

     <b-modal :ref="'contact_info_modal'" id="contact_info_modal" size="xl" :title="'Contact Information'" ok-only header-class="border-bottom-0">
      <b-row>
        <b-col class="font-weight-bold col-3">
          <h3>Subject Name:</h3>
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          <h3 class="font-weight-light">{{ selected_subject.subject_case.subject_name }}</h3>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Household:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.head_of_household }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Relation to HoH:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.relation_to_head }}
        </b-col>
      </b-row>

      <b-row>
        <b-col class="font-weight-bold col-3">
          Telephone Number:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.telephone_number }}
        </b-col>
      </b-row>

      <b-row v-if="selected_subject != null && selected_subject.subject_case.second_telephone_number != null">
        <b-col class="font-weight-bold col-3">
          Second Telephone Number:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.second_telephone_number }}
        </b-col>
      </b-row>

      <br />

       <b-row>
        <b-col class="font-weight-bold col-3">
          Consenting Adult:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.subject_consenting_person }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Consenting Adult Telephone:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.subject_consenting_phone }}
        </b-col>
      </b-row>

      <br />

       <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Structure:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.structure.head_of_structure }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Structure Telephone:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.head_of_structure_phone }}
        </b-col>
      </b-row>
    </b-modal>
  </div>
  
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
// import SubjectFinalStatusRequestTable from "@/pages/unitaid/subject-final-status/SubjectFinalStatusRequests.vue";

import { mapActions, mapState } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    // SubjectFinalStatusRequestTable
  },
  data: function() {
    return {
      fields: [
        { key: "subject_id" },
        { key: "followup_form_submitted_date", label: "Date of Incomplete" },
        { key: "subject_followup_incomplete_reason", label: "Reason Incomplete" },
        { key: "table_name", label: "Location" },
        { key: "submitted_by_user_followup", label: 'Submitted By CI / CO'},
        { key: "dismiss", label: "Dismiss", class: "right-text"}
      ],
      dismissed_fields: [
        { key: "subject_id" },
        { key: "followup_form_submitted_date", label: "Date of Incomplete" },
        { key: "subject_followup_incomplete_reason", label: "Reason Incomplete" },
        { key: "table_name", label: "Location" },
        { key: "submitted_by_user_followup", label: 'Submitted By CI / CO'}
      ],
      visits: [],
      dismissed_visits: [],
      componentKey: 0,
      selected_subject: null,
      filter: null,
    };
  },
  computed: {

    ...mapState("user", ["user", "myGroups"]),
  },
  mounted: function() {
    let that = this;
     HTTP.get("/kenya/subjects_incomplete_visit/get_list").then(response => {
      response.data.forEach(element => {
        if(element.dismissed){
          that.dismissed_visits.push(element);
        }
        else{
          that.visits.push(element);
        }
      });
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
    ...mapActions("incomplete_visits", [
      "getIncompleteVisitsCount",
      "setIncompleteVisitsCount"
    ]),

    refreshSideNavCount(){
      this.getIncompleteVisitsCount().then((response) => {
                this.setIncompleteVisitsCount(response.data);
            });
    },
     rowClicked(record, index){
      let that = this;
      that.selected_subject = record;
      this.showModal(index);
    },
    showModal() {
        this.$refs[('contact_info_modal')].show();
      },
    dismiss_clicked(record){
      let that = this;
      const fd = new FormData();

      fd.append('table_name', record.table_name);
      fd.append('row_id', record.id);

      HTTP.post('/kenya/dismiss_row/', fd).then(() => {
          for(var i = 0; i < that.visits.length; i++){
            if(that.visits[i].id == record.id){
              that.visits.splice(i, 1);
              that.dismissed_visits.push(record);
              break;
            }
          }
          that.refreshSideNavCount();
      }).catch(error => {
        HandleErrors.HandleErrors(error);
      });
    }
  }
};
</script>

<style>
.right-text{
  text-align: right;
}

.clickable {
  cursor: pointer;
}
</style>